import NewEventForm from '../../components/newEventForm/NewEventForm';
import * as Yup from 'yup';
import {newEventInitialValues,newEventSteps, newEventValidationSchema} from '../../globalSteps';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

function NewGivechakEvent() {
    const event=useSelector(s=>s.event);
    const {t} = useTranslation(['global', 'newEvent', 'errors', 'layout']);
    const {isOpenLocaleStep, duplicateSourceEid} = useSelector((s) => ({
        isOpenLocaleStep: s.ui.event.isOpenLocaleStep,
        duplicateSourceEid: s.ui.event.duplicateSourceEid
    }));
    
    const givechakSteps=[
        {...newEventSteps.title,texts:{header:'givechakTitleHeader'},compProps:{text:'givechakTitleHeader',description:'givechakDescriptionText'}},
        {...newEventSteps.date,texts:{description:'dateTopHeaderGivechakDesc',header:'dateTopHeaderGivechak'}},
        ...(isOpenLocaleStep ? [newEventSteps.locale] : []),
        ...(duplicateSourceEid ? [] : [{...newEventSteps.target, texts: {header: 'targetText'}}]),
        {...newEventSteps.description,texts:{description:'descriptionHeaderGivechakDesc',header:'descriptionHeaderGivechak'}}
    ];
    
    const {title, description, date, locale}=newEventInitialValues(event);
    
    const initialValues = {
        title,
        description,
        date,
        locale,
        ...(duplicateSourceEid ? {} : {target: event.target})
    };
    const {title: titleValid, description: descriptionValid, locale: localValid, date: dateValid}=newEventValidationSchema(t);

    const initialValidationSchema = Yup.object().shape({
        title: titleValid,
        description: descriptionValid,
        locale: localValid,
        date: dateValid,
        ...(duplicateSourceEid ? {} : {target: Yup.number().required()})
    });

    return (
        <NewEventForm
            initialValues={initialValues}
            validationSchema={initialValidationSchema}
            steps={givechakSteps}
        />
    );
}

export default NewGivechakEvent;
